// 分域名方案（单一数据源）：正式域名 ↔ 默认语言
// www.szcofoe.com 英文站（服务器在国外），cn.szcofoe.com 中文站（服务器在国内）
// 说明：域名只决定"用户未手动切换过"时的默认语言；语言切换为站内切换，
// 用户选择记录在 localStorage（按域名独立存储），不做跨域名跳转
// 注意：index.html 的静态标题/描述语言由构建模式决定（.env.en / .env.cn，见 package.json 的
// build:en / build:cn），与此处的域名映射配合使用
const DOMAIN_LOCALE = {
  'www.szcofoe.com': 'en',
  'szcofoe.com': 'en', // 裸域，通常由 nginx 跳转到 www
  'cn.szcofoe.com': 'zh'
}

// 访问域名对应的默认语言；未识别域名（本地开发、IP 访问等）返回 null
export function getDomainLocale(hostname) {
  const host = (hostname || window.location.hostname || '').toLowerCase()
  return DOMAIN_LOCALE[host] || null
}
